// We pass axios here in order to be able to mock it in other stacks
import axios from 'axios';

export * from 'axios';
export default axios;
